import React, { useRef } from 'react';

import { FormikHelpers } from 'formik';

import OnboardingSelect from 'components/Selects/OnboardingSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Error } from './styles';

export interface Props {
  id?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  formik?: FormikHelpers<string>;
  onValueChange?: (value: boolean) => void;
}

type Option = {
  id: 'specific' | 'all';
  name: string;
};

const AllowedUserSelect = ({ value, formik, error, disabled, onValueChange }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useStoreTranslation();
  const OPTIONS: Option[] = [
    { id: 'specific', name: t('userForm.travelerUsersAllowed.specific') },
    { id: 'all', name: t('userForm.travelerUsersAllowed.all') },
  ];

  const handleChange = (newValue: string) => {
    const booleanValue = newValue === 'all';
    formik?.setFieldValue('isAllUsersBookAllowed', booleanValue);
    if (onValueChange) onValueChange(booleanValue);
  };
  const getValue = () => {
    if (value === undefined) return undefined;
    return value ? 'all' : 'specific';
  };

  return (
    <div ref={ref}>
      <OnboardingSelect
        disabled={disabled}
        title={t('userForm.travelerUsersAllowed.title')}
        options={OPTIONS}
        value={getValue()}
        onChange={handleChange}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default AllowedUserSelect;
